var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgErrorToast = function SvgErrorToast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12889",
    transform: "translate(-3228 -1182)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#ffc1c2",
    "data-name": "Ellipse 777",
    transform: "translate(3228 1182)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff3e3e",
    stroke: "#ff3e3e",
    strokeWidth: 0.5,
    d: "M3237.231 1199.652a.79.79 0 0 0 1.117 1.117l3.652-3.653 3.652 3.653a.79.79 0 0 0 1.117-1.117l-3.653-3.652 3.653-3.652a.79.79 0 0 0-1.117-1.117l-3.652 3.653-3.652-3.653a.79.79 0 0 0-1.117 1.117l3.653 3.652Z",
    "data-name": "Path 30367"
  }))));
};
export default SvgErrorToast;